// EmblemForm.tsx
import React, { useState } from 'react';
import { instance } from '../../api/axiosInstance'; // 위에서 만든 axios 인스턴스 import
import ManagerSidebar from '../../components/ManagerSidebar';
import NoticeComponent from '../../components/NoticeComponent';
import { FaUpload } from 'react-icons/fa6';

const EmblemForm: React.FC = () => {
  const [formData, setFormData] = useState({
    name: '',
    tag: '',
    description: '',
    status: '미보유',
  });

  const [imageFile, setImageFile] = useState<File | null>(null);

  // handleChange 타입 확장: input, textarea, select 모두 처리 가능
  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setImageFile(event.target.files[0]);
    }
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    // 간단한 유효성 검사
    if (!formData.name || !imageFile) {
      alert('Name and Image are required.');
      return;
    }

    // FormData 객체 생성
    const data = new FormData();
    data.append('name', formData.name);
    data.append('tag', formData.tag);
    data.append('description', formData.description);
    data.append('status', formData.status);
    data.append('image', imageFile);

    try {
      const response = await instance.post('/api/emblems', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      alert('Emblem registered successfully!');
      // 폼 초기화
      setFormData({
        name: '',
        tag: '',
        description: '',
        status: '미보유',
      });
      setImageFile(null);
    } catch (error) {
      console.error(error);
      alert('Failed to register emblem.');
    }
  };

  return (
    <section className="max-w-[2560px] w-full mx-auto h-screen flex mt-[90px]">
        <ManagerSidebar />
        <div className="max-w-[1440px] w-full mx-auto py-8 flex flex-col flex-1 overflow-auto overflow-x-hidden ">
          <NoticeComponent title="엠블럼 등록" content="" />
          {/* <h2 className="text-2xl font-semibold mb-4">엠블럼 등록</h2> */}
          <div className="max-w-[700px] bg-white">
            <form onSubmit={handleSubmit} encType="multipart/form-data">
              <div className="mb-4">
                <label className="block mb-1">엠블럼 이름</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full h-[45px] px-3 py-2 border rounded-md focus:outline-none "
                  required
                />
              </div>
              <div className="mb-4">
                <label className="block mb-1">엠블럼 이미지</label>
                <input
                  type="file"
                  name="image"
                  accept="image/png, image/jpeg"
                  onChange={handleFileChange}
                  className="w-full text-sm text-gray-500 !cursor-pointer file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-MainTextColor file:text-white hover:file:bg-MainColor !transition !duration-300 !ease-in-out"
                  required
                />
                {imageFile && (
                  <img
                    src={URL.createObjectURL(imageFile)}
                    alt="Preview"
                    className="mt-2 w-32 h-32 object-cover border rounded-md"
                  />
                )}
              </div>
              <div className="mb-4">
                <label className="block mb-1">엠블럼 태그</label>
                <input
                  type="text"
                  name="tag"
                  value={formData.tag}
                  onChange={handleChange}
                  className="w-full h-[45px] px-3 py-2 border rounded-md focus:outline-none "
                />
              </div>
              <div className="mb-4">
                <label className="block mb-1">엠블럼 설명</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  className="w-full px-3 py-2 border rounded-md focus:outline-none "
                ></textarea>
              </div>
              <div className="mb-4">
                <label className="block mb-1">엠블럼 상태</label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  className="w-full h-[45px] px-3 py-2 border rounded-md focus:outline-none "
                >
                  <option value="미보유">미보유</option>
                  <option value="보유">보유</option>
                </select>
              </div>
              {/* Submit Button */}
              <button
                type="submit"
                className="w-full mt-8 bg-black text-white font-bold text-sm py-4 rounded-lg hover:bg-opacity-70 transition duration-300"
              >
                <div className="flex items-center justify-center gap-3">
                  <FaUpload />
                  엠블럼 등록하기
                </div>
              </button>
            </form>
          </div>
        </div>
    </section>
  );
};

export default EmblemForm;
